const CheckboxSVG = () => (
  <svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.55491 13.1098C10.1751 13.1098 13.1098 10.1751 13.1098 6.55491C13.1098 2.93474 10.1751 0 6.55491 0C2.93474 0 0 2.93474 0 6.55491C0 10.1751 2.93474 13.1098 6.55491 13.1098ZM9.86117 5.0764C10.0949 4.76985 10.0358 4.33187 9.72927 4.09817C9.42271 3.86446 8.98474 3.92352 8.75103 4.23008L6.16635 7.62044L4.90602 6.10805C4.65924 5.81192 4.21912 5.7719 3.92299 6.01868C3.62685 6.26546 3.58684 6.70558 3.83362 7.00172L6.21491 9.85927L9.86117 5.0764Z"
      fill="currentColor"
    />
  </svg>
);

export default CheckboxSVG;
